import { render, staticRenderFns } from "./entity-info-item.vue?vue&type=template&id=213e2713&scoped=true"
import script from "./entity-info-item.vue?vue&type=script&lang=ts"
export * from "./entity-info-item.vue?vue&type=script&lang=ts"
import style0 from "./entity-info-item.vue?vue&type=style&index=0&id=213e2713&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e2713",
  null
  
)

export default component.exports